/* eslint-disable react/display-name */
import { forwardRef } from 'react';

export const Item = forwardRef(({ _id, _listeners, _attributes, _index, imageUrl, style, activeid, drag, ...domProps }, ref) => {
  if (!imageUrl) return;
  return (
    <div
      className={
        'bg-base-100 h-28 flex-grow cursor-grab rounded-sm text-xl drop-shadow-[0_1px_2px_rgba(0,0,0,0.25)] active:cursor-grabbing md:h-28 ' +
        (activeid === 'true' ? 'opacity-50 ' : '') +
        (drag ? 'shadow-2xl ' : '')
      }
      ref={ref}
      style={{ touchAction: 'none', ...style }}
      {...domProps}
    >
      {imageUrl?.uploaded === true ? (
        <div className='relative flex h-full w-full'>
          <div
            className='relative h-full w-full bg-contain bg-center bg-no-repeat'
            style={{ backgroundImage: `url(${imageUrl.result})` }}
          />
        </div>
      ) : (
        <div className='relative flex h-full w-full'>
          <div
            className='h-full w-full bg-contain bg-center bg-no-repeat'
            style={{ backgroundImage: `url(${import.meta.env.VITE_IMAGE_URL}${imageUrl})` }}
          />
        </div>
      )}
    </div>
  );
});
